import { render, staticRenderFns } from "./PazymosMeniu.vue?vue&type=template&id=1f2792f1&scoped=true&"
import script from "./PazymosMeniu.vue?vue&type=script&lang=js&"
export * from "./PazymosMeniu.vue?vue&type=script&lang=js&"
import style0 from "./PazymosMeniu.vue?vue&type=style&index=0&id=1f2792f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2792f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
